<button type="button" class="user-info-component" [matMenuTriggerFor]="userMenu" aria-label="User menu">
  <span class="user-avatar">
    @if (avatarSrc) {
      <img [src]="avatarSrc" alt="User avatar" class="avatar-img" />
    } @else {
      <span>{{ getUserInitial() }}</span>
    }

  </span>
  <span class="user-name">
    {{ account?.firstName }} {{ account?.lastName }}
  </span>
  <mat-icon class="dropdown-icon">keyboard_arrow_down</mat-icon>
</button>

<mat-menu #userMenu="matMenu" class="custom-menu-panel" (closed)="onMenuClosed()">
  <div class="profile-dropdown" (click)="$event.stopPropagation()">
    @if (!loading) {
      <div>
        <div class="view-profile-section">
          <div class="profile-left">
            <div class="view-avatar">
              @if (avatarSrc) {
                <img [src]="avatarSrc" [alt]="avatarSrc" class="avatar-img" />
              } @else {
                <span>{{ getUserInitial() }}</span>
              }
            </div>
            @if (canChangingPhoto) {
              <button
                type="button"
                class="change-photo-btn"
                (click)="openPhotoEditor()"
                >
                <img
                  class="edit-icon"
                  [src]="'shared-assets/icons/edit.svg'"
                  alt="Edit icon"
                  />
                <span>Change profile photo</span>
              </button>
            }
          </div>
        </div>
        <div class="form-group">
          <div class="text-input-wrapper disabled">
            <label>First Name</label>
            <div class="text-input-container">
              <input type="text" [value]="account?.firstName ?? ''" disabled />
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="text-input-wrapper disabled">
            <label>Last Name</label>
            <div class="text-input-container">
              <input type="text" [value]="account?.lastName ?? ''" disabled />
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="text-input-wrapper disabled">
            <label>Company Position</label>
            <div class="text-input-container">
              <input type="text" [value]="account?.position ?? ''" disabled />
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="text-input-wrapper disabled">
            <label>Email</label>
            <div class="text-input-container">
              <input type="text" [value]="account?.email ?? ''" disabled />
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="text-input-wrapper">
            <label>Role</label>
            <div class="text-input-container" [matTooltip]="groupNames" matTooltipPosition="above">
              <input type="text" [value]="groupNames" disabled />
            </div>
          </div>
        </div>
        @if(showClientDetails()) {
          <div class="form-group" animate.enter="client-details-in" animate.leave="client-details-out">
            <app-text-input
              label="Client ID"
              [ngModel]="clientId()"
              [type]="'text'"
              [showCopyIcon]="true"
              [inputSize]="'sm'"
              [placeholder]="'Client ID'"
              [readOnly]="true"
              >
            </app-text-input>
          </div>
          <div class="form-group">
            <app-text-input
              label="Secret code"
          [helperLinkPermission]="{
            resource: Resources.Merchants,
            scope: Scopes.ResetClientCecret
          }"
              [ngModel]="secretCode()"
              [type]="hideSecret() ? 'password' : 'text'"
          [icon]="{
            name: hideSecret() ? 'visibility_off' : 'visibility',
            tooltip: hideSecret() ? 'Show Secret Code' : 'Hide Secret Code'
          }"
              (iconClick)="toggleSecret()"
              [showCopyIcon]="true"
              [inputSize]="'sm'"
              [helperLink]="'Reset Client Secret'"
              (helperLinkClick)="resetSecret()"
              [placeholder]="'Secret code'"
              [readOnly]="true"
              >
            </app-text-input>
          </div>
        }
        <div class="form-actions">
          @if(!isSettlementApp() && canViewClient()) {
            <app-button buttonVariant="user-secondary" buttonType="button" (buttonClick)="onShowClientDetails()">
              {{ showClientDetails() ? 'Hide API Credentials' : 'Show API Credentials' }}
            </app-button>
          }
          <app-button buttonVariant="user-primary" buttonType="button" (buttonClick)="logout()">
            Logout
          </app-button>
        </div>
      </div>
    }
    @if (loading) {
      <div class="loading-container">
        <app-loading-spinner size="large" label="Loading profile..."></app-loading-spinner>
      </div>
    }
  </div>
</mat-menu>
